import { routesSoatVentas, routesSoatVentasGestion } from "./SoatVenta/routes";

export const routesSoatRefacil = [...routesSoatVentas];
export const routesSoatRefacilGestion = [...routesSoatVentasGestion];
